import { render, staticRenderFns } from "./ResendPopUp.vue?vue&type=template&id=2912b076&lang=pug&"
import script from "./ResendPopUp.vue?vue&type=script&lang=js&"
export * from "./ResendPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports